"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _variables = require("../common/variables.js");

var _utils = require("../common/utils.js");

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _BackgroundColorContext = require("../BackgroundColorContext");

var _templateObject, _templateObject2;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DxcTable = function DxcTable(_ref) {
  var children = _ref.children,
      margin = _ref.margin;
  var colorsTheme = (0, _useTheme["default"])();
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.table
  }, /*#__PURE__*/_react["default"].createElement(DxcTableContainer, {
    margin: margin
  }, /*#__PURE__*/_react["default"].createElement(DxcTableContent, null, /*#__PURE__*/_react["default"].createElement(_BackgroundColorContext.BackgroundColorProvider, {
    color: colorsTheme.table.dataBackgroundColor
  }, children))));
};

var calculateWidth = function calculateWidth(margin) {
  return "calc(100% - ".concat((0, _utils.getMargin)(margin, "left"), " - ").concat((0, _utils.getMargin)(margin, "right"), ")");
};

var DxcTableContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  width: ", ";\n  margin: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n\n  overflow: auto;\n  &::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: ", ";\n    border-radius: 6px;\n  }\n  &::-webkit-scrollbar-track {\n    background-color: ", ";\n    border-radius: 6px;\n  }\n"])), function (props) {
  return calculateWidth(props.margin);
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) !== "object" ? _variables.spaces[props.margin] : "0px";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.top ? _variables.spaces[props.margin.top] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.right ? _variables.spaces[props.margin.right] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.bottom ? _variables.spaces[props.margin.bottom] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.left ? _variables.spaces[props.margin.left] : "";
}, function (props) {
  return props.theme.scrollBarThumbColor;
}, function (props) {
  return props.theme.scrollBarTrackColor;
});

var DxcTableContent = _styledComponents["default"].table(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  border-collapse: collapse;\n  width: 100%;\n\n  & tr {\n    border-bottom: ", ";\n    height: 60px;\n  }\n  & td {\n    background-color: ", ";\n    font-family: ", ";\n    font-size: ", ";\n    font-style: ", ";\n    font-weight: ", ";\n    color: ", ";\n    text-transform: ", ";\n    text-align: ", ";\n    line-height: ", ";\n    padding: ", ";\n  }\n  & th {\n    background-color: ", ";\n    font-family: ", ";\n    font-size: ", ";\n    font-style: ", ";\n    font-weight: ", ";\n    color: ", ";\n    text-transform: ", ";\n    text-align: ", ";\n    line-height: ", ";\n    padding: ", ";\n  }\n  & th:first-child {\n    border-top-left-radius: ", ";\n  }\n  & th:last-child {\n    border-top-right-radius: ", ";\n  }\n  & td:last-child {\n    padding-right: 40px;\n  }\n"])), function (props) {
  return "".concat(props.theme.rowSeparatorThickness, " ").concat(props.theme.rowSeparatorStyle, " ").concat(props.theme.rowSeparatorColor);
}, function (props) {
  return props.theme.dataBackgroundColor;
}, function (props) {
  return props.theme.dataFontFamily;
}, function (props) {
  return props.theme.dataFontSize;
}, function (props) {
  return props.theme.dataFontStyle;
}, function (props) {
  return props.theme.dataFontWeight;
}, function (props) {
  return props.theme.dataFontColor;
}, function (props) {
  return props.theme.dataFontTextTransform;
}, function (props) {
  return props.theme.dataTextAlign;
}, function (props) {
  return props.theme.dataTextLineHeight;
}, function (props) {
  return "".concat(props.theme.dataPaddingTop, " ").concat(props.theme.dataPaddingRight, " ").concat(props.theme.dataPaddingBottom, " ").concat(props.theme.dataPaddingLeft);
}, function (props) {
  return props.theme.headerBackgroundColor;
}, function (props) {
  return props.theme.headerFontFamily;
}, function (props) {
  return props.theme.headerFontSize;
}, function (props) {
  return props.theme.headerFontStyle;
}, function (props) {
  return props.theme.headerFontWeight;
}, function (props) {
  return props.theme.headerFontColor;
}, function (props) {
  return props.theme.headerFontTextTransform;
}, function (props) {
  return props.theme.headerTextAlign;
}, function (props) {
  return props.theme.headerTextLineHeight;
}, function (props) {
  return "".concat(props.theme.headerPaddingTop, " ").concat(props.theme.headerPaddingRight, " ").concat(props.theme.headerPaddingBottom, " ").concat(props.theme.headerPaddingLeft);
}, function (props) {
  return props.theme.headerBorderRadius;
}, function (props) {
  return props.theme.headerBorderRadius;
});

var _default = DxcTable;
exports["default"] = _default;